import { object } from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";
import ImageType4 from "../../../../components/molecules/image-type-4";
import { getCollectionitems } from "../../../../../api/utils";
import "../../../../components/pages/section.m.css";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";
import "./misc-episode-listing-layout.m.css";
import { reformStoryItems, findEpisodeIndex } from "./helpers";

const MiscEpisodeListingLayout = ({ data }) => {
  const underSubscriptionIcon = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "under_subscription_icon"], ""));
  const collectionSlug = data?.collection?.slug || null;
  const initialStories = data?.collection?.items?.map((itemsStory) => itemsStory.story) || [];
  const reformedObjectContents = reformStoryItems(initialStories);
  const [stories, setStories] = useState(initialStories);
  const [offset, setOffset] = useState(initialStories.length);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const limit = 19;

  const onLoadMoreClick = async () => {
    setLoading(true);

    try {
      if (!collectionSlug) {return;}
      const resultItems = await getCollectionitems(collectionSlug, offset, limit);
      const newStories = resultItems?.map((itemsStory) => itemsStory.story) || [];

      if (newStories.length === 0) {
        setHasMore(false);
      } else {
        setStories((prev) => [...prev, ...newStories]);
        setOffset((prev) => prev + newStories.length);
      }
    } catch (err) {
      console.error("Error loading more episodes:", err);
    } finally {
      setLoading(false);
    }
  };

  const goPrevPage = () => {
    if (typeof window !== "undefined") {
      if (document.referrer && document.referrer.includes(window.location.host)) {
        window.history.back();
      } else {
        window.location.href = "/";
      }
    }
  };

  return (
    <div styleName="container">
      <div styleName="main-contents">
        <div styleName="episodes-grid-wrapper">
          <h2 styleName="collection-name" onClick={goPrevPage} style={{cursor: "pointer"}}><span><i className="ri-arrow-left-line"></i>&nbsp;</span>{data?.collection?.name}</h2>

          <div>
            <ul styleName="image-container-new">
              {stories.length >= 1 &&
              stories.map((item) => {
                const [seriesSlug, seasonSlug, episodeSlug] = item.slug.split("/");
                const findEpisodePublishedOrderInSeason = findEpisodeIndex(reformedObjectContents, seriesSlug, seasonSlug, episodeSlug);
                const publishedSeason = (item.sections?.[0].name).split("/")[0];
                const paywallIcons = item?.access === "login" || item?.access === "subscription";

                return (
                  <li>
                    <div id={item.id}>
                      <ImageType4 story={item} aspectRatio={[[16, 9]]} />
                      <div styleName="episodes-headline-icon">
                        <h2>{item.headline}</h2>
                        {paywallIcons && (
                          <img alt="audio-logo" src={underSubscriptionIcon} styleName="custom-img-icon" />
                        )}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>


          {hasMore && (
            <div styleName="title-loadmore">
              <button styleName="btn-2" onClick={onLoadMoreClick} disabled={loading}>
                {loading ? "Ladataan..." : "Lataa lisää"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

MiscEpisodeListingLayout.propTypes = {
  data: object
};

export { MiscEpisodeListingLayout };
